/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {resetStagingJira} from '../api'

export const useMutationResetStagingJira = createReactQueryMutationHook('resetStagingJira', resetStagingJira)
